<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div style="margin: 10px 0;"><el-tag size="small" type="success" effect="dark">setp 1</el-tag> 选择要显示的订单属性
          <el-button type="primary"  size="mini" style="margin-left: 10px" @click="openItem">调整顺序</el-button>
          <el-button type="primary"  size="mini" style="margin-left: 10px" @click="saveField">保存顺序到本地</el-button>
          <el-button type="primary"  size="mini" style="margin-left: 10px" @click="addField">保存顺序到服务器</el-button>
          <el-button type="primary"  size="mini" style="margin-left: 10px" @click="getField">从服务器下载顺序</el-button>
          <el-button type="primary"  size="mini" style="margin-left: 10px" @click="refresh">刷新</el-button>
        </div>
        <div style="padding-left: 15px">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>

        </div>
        <div class="border">
          <el-checkbox-group   v-model="checkedFields" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="field in fieldOptions" :label="field.field" :key="field.title" style="margin-top:6px;width:80px;font-size:10px ">{{field.title}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-col>
    </el-row>
    <div style="margin: 10px 0;"><el-tag size="small" type="success" effect="dark" >setp 2</el-tag> 选择要同步的订单时间段（开始时间和结束时间，不得相差超过1个月）</div>
    <div style="margin: 10px 0;"></div>
    <el-row>
      <el-col :span="24">
        <div class="border15">
          <el-select v-model="synValue" size="small" style="width: 150px" placeholder="请选择">
            <el-option
              v-for="item in synOpto"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker
            style="" size="small"
            :default-time="['00:00:00', '23:59:59']"
            v-model="tradeDate"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right">
          </el-date-picker>

          <el-checkbox-group v-model="checkedStatus">
            <el-checkbox v-for="item in statusOpto" :label="item.field" :key="item.title" style="margin-top: 10px;width:100px ">{{item.title}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-col>
    </el-row>
    <div style="margin: 10px 0;"><el-tag size="small" type="success" effect="dark">setp 3</el-tag> 开始从1688同步订单</div>
    <div style="margin: 10px 0;"></div>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="startTrade">同步订单</el-button>
        <el-button v-show="showAsc" type="primary" @click="getAsc">同步退货单</el-button>
        <el-button v-show="false"type="primary" @click="startMemo">同步备注</el-button>
        <el-button v-show="showCoup" type="primary" @click="getCoup">同步优惠</el-button>

        <el-button type="primary" @click="gotoShow">查看订单</el-button>
        <div id="loading" style="display: none; margin-left: 20px; ">
          <span class="el-icon-loading" style="font-size:20pt;margin-right: 6px"></span><span style="font-size: 14px">数据同步中......</span>
        </div>
        {{msg}}
      </el-col>
    </el-row>

    <div style="margin: 30px 0;"><el-tag size="small" >提示</el-tag> <span style="margin-left: 10px; color: #0000ff"> 订单同步完成后，请点击查看订单</span></div>

    <div style="margin: 10px 0;display: none"><el-tag size="small" type="success" effect="dark">示例</el-tag> 订单属性显示顺序（预览）<span style="margin-left: 10px; color: #0000ff"> ↑ 显示数据点上面 ↑，这里不显示数据，不显示数据，不显示数据，重要的事说三遍！只用于预览您设置的显示项目</span></div>
    <div style="margin: 10px 0;"></div>
    <el-row v-if="false">
      <el-col :span="24">
        <el-table :data="tradeData"  border  :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <template v-for='(col) in myFields'>
            <el-table-column
              :show-overflow-tooltip="true"
              :prop="col.field"
              :label="col.title"
              :key="col.field"
              width="124px">
            </el-table-column>
          </template>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog
      title="调整显示顺序"
      :visible.sync="showItem"
      width="600px"
      center>
      <div style="margin-left:5px; margin-bottom: 20px">
        <span >说明：这里显示您已经勾选的项目，主图顺序不支持调整</span>
      </div>
      <div style="height:400px; overflow:auto">
        <el-table border :data="seqFields" :header-cell-style="{background:'#F2F6FC',color:'#000'}" ref="singleTable"  highlight-current-row
                  @current-change="handleCurrentChange"  class="hover">
          <el-table-column  label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="title" label="字段名" width="160px"></el-table-column>
          <!--<el-table-column  label="" width="80px">
            <template slot-scope="scope">
              <el-button type="primary" size="mini"  style="display: inline" @click="moveUp(scope.$index, scope.row)">上移</el-button>
            </template>
          </el-table-column>
          <el-table-column  label="" width="80px">
            <template slot-scope="scope">
              <el-button type="success" size="mini"  style="display: inline" @click="moveDown(scope.$index, scope.row)">下移</el-button>
            </template>
          </el-table-column>-->
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" size="" @click="up">上移</el-button>
          <el-button type="success" size="" @click="down" style="margin-right: 50px">下移</el-button>

        <el-button type="primary" @click="saveItem">确 定</el-button>
        <el-button @click="cancelItem">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
    import storage from "../api/storage";
    import $api from "../api/axios";
    import cookies from "../api/cookie";
    import datefmt from "../api/date";
    import isInSameMonth from "../api/date"

    export default {
        //name: "ShowSet",
        data(){
          return{

            fieldOptions : [{title:'订单号', field:'tidStr',span:1 },{title:'买家ID', field:'buyerLoginId',span:1 },{title:'拍下时间', field:'createTime',span:1 },
              {title:'付款时间', field:'payTime',span:1 },{title:'应付总金额', field:'totalAmount',span:1 },{title:'邮费', field:'shippingFee',span:1 },
              {title:'优惠', field:'discount',span:1 },{title:'收货信息', field:'maskInfo',span:1 },{title:'收货地址', field:'maskAddr1',span:1 },
              {title:'姓名', field:'maskName',span:1 },{title:'手机', field:'maskMobile',span:1 },{title:'电话', field:'maskPhone',span:1 },
              {title:'省份', field:'toState',span:1 },{title:'城市', field:'toCity',span:1 },{title:'区县', field:'toDistrict',span:1 },
              {title:'街道', field:'toTown',span:1 },{title:'地址', field:'maskAddress',span:1 },{title:'订单状态', field:'tdstatus',span:1 },
              {title:'买家留言', field:'buyerFeedback',span:1 },{title:'卖家备注', field:'sellerMemo',span:1 },{title:'备注旗帜', field:'sellerFlag',span:1 },
              {title:'子订单号', field:'oidStr',span:0 },{title:'商品ID', field:'productID',span:0 },{title:'商品名称', field:'title',span:0 },
              {title:'货号', field:'productCargoNumber',span:0 },{title:'简称', field:'shortName',span:0 },{title:'成本', field:'cost',span:0 },
              {title:'skuID', field:'skuID',span:0 },{title:'单品货号', field:'cargoNumber',span:0 },{title:'颜色', field:'color',span:0 },
              {title:'尺码', field:'size',span:0 },{title:'名称颜码', field:'ttlProp',span:0 },
              {title:'数量', field:'quantity',span:0 },{title:'单价', field:'price',span:0 },
              {title:'子订单状态', field:'statusStr',span:0 },{title:'退款状态', field:'refundStts',span:0 },{title:'是否可发货', field:'canSendGoods',span:0 },
              {title:'原因', field:'cantSendReason',span:0 },{title:'物流公司', field:'logisticsCompanyName',span:0 },{title:'物流单号', field:'logisticsBillNo',span:0 },
              {title:'发货时间', field:'allDeliveredTime',span:0 }, {title:'主图', field:'picPath',span:0 },
            ],
            statusOpto:[{title:'等待卖家发货',field:'waitsellersend'},{title:'等待确认收货',field:'waitbuyerreceive'},
              {title:'交易成功',field:'success'},{title:'交易关闭',field:'cancel'},{title:'等待买家付款',field:'waitbuyerpay'}],
             checkAll: false,
            //勾选的项目
            checkedFields: ['tid','buyerLoginId','payTime','totalAmount','maskName','maskMobile','title','quantity'],
            //保存勾选项目
            myFields:[{title:'订单号', field:'tid',span:1 },{title:'买家ID', field:'buyerLoginId',span:1 },
              {title:'付款时间', field:'payTime',span:1 },{title:'应付总金额', field:'totalAmount',span:1 },{title:'姓名', field:'maskName',span:1 },
              {title:'手机', field:'maskMobile',span:1 },{title:'商品名称', field:'title',span:0 },
              {title:'数量', field:'quantity',span:0 }],
            //调整勾选项目
            seqFields:[],

            isIndeterminate: true,

            data: [],
            value: [],

            synOpto: [{ value: 'created', label: '拍下时间'},{ value: 'payTime', label: '付款时间'},{ value: 'modified', label: '修改时间'}],
            synValue:'created',
            tradeDate:[],
            checkedStatus:['waitsellersend'],

            timer:null,
            timer2:null,
            funName:'',
            cnName:'',
            //同步完成后提示
            msg:"",
            //同步操作是否正在进行
            isdoing: '0',
            //自动从服务器下载显示项
            autoDownload:true,
            //调整显示顺序
            showItem:false,
            //
            tradeData:[],

            //同步退货单
            showAsc:false,
            //同步优惠
            showCoup:false,
            //
            currentRow:null,
            pickerOptions: {
              shortcuts: [{
                text: '今天',
                onClick(picker) {
                  const end = new Date();

                  let year2, month2, day2
                  [year2, month2, day2] = [end.getFullYear(), end.getMonth(), end.getDate()]
                  let start = new Date(year2, month2, day2, 0)
                  picker.$emit('pick', [start, end]);
                }
              },{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
          }
        },
      methods:{
        refresh(){
          this.$router.go(0);
        },
        handleCheckAllChange(val) {
          //this.checkedCities = val ? cityOptions : [];
          this.checkedFields=[];
          if(val) {
            for (let i = 0; i < this.fieldOptions.length; i++) {
              this.checkedFields.push(this.fieldOptions[i].field)
            }
          }else{
            this.checkedFields = [];
          }
          this.fillTitle();
          this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
          let checkedCount = value.length;
          this.checkAll = checkedCount === this.fieldOptions.length;
          this.isIndeterminate = checkedCount > 0 && checkedCount < this.fieldOptions.length;

          this.fillTitle();

          this.saveField();
        },
        //填充表格要显示的列名称， 有主图时，主图显示在最后一列
        fillTitle:function(){
          this.myFields = [];
          for (let i = 0; i < this.checkedFields.length; i++) {
            let key = this.checkedFields[i];
            for(let j=0;j<this.fieldOptions.length;j++){
              if(key == this.fieldOptions[j].field){
                this.myFields.push(this.fieldOptions[j]);
                break;
              }
            }
          }
          let option = null;
          let i=0;
          for(i=0;i<this.myFields.length;i++){
            let option = this.myFields[i];
            if(option.title=="主图"){
              if(i<this.myFields.length){
                this.myFields.splice(i,1);
                this.myFields.push(option);
                storage.set("showImg", "1");
              }
              break;
            }
          }
          if(i>=this.myFields.length){
            storage.set("showImg","0");
          }
        },
        //查看数据
        gotoShow:function(){
          this.$router.replace({name:"ShowData"});
          storage.set("active","3");
        },
        //轮询同步状态
        getStatus:function () {
          console.log("get1.");
          this.msg='';
          let param={
            nick:storage.get("nick"),
            subNick:"",
            funName:this.funName,
            status:"1",
          }
          console.log(this.funName);
          $api.post("/trade/getStatus", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.data == "success") {
              clearTimeout(this.timer);
              //this.$message.success("【"+this.cnName +"】数据同步完成。");
              this.msg="【"+this.cnName +"】数据同步完成，请点 [ 显示数据 ]。";
              window.document.getElementById("loading").style.display = 'none';
            }
            else {
              this.timer = setTimeout(this.getStatus, 3000);
              this.msg='数据同步中.....';
              //this.$message.warning("【"+this.cnName +"】数据同步中.....");
              window.document.getElementById("loading").style.display = 'inline-block';
            }
          })
        },
        //轮询同步状态
        getStatus2:function () {
          this.msg='';
          let param={
            nick:storage.get("nick"),
            subNick:"",
            funName:this.funName,
            status:"1",
          }
          $api.post("/trade/getStatus", param, response =>{
            let dataResult =  response.data;
            if(dataResult.data == "success") {
              clearTimeout(this.timer2);
              this.$message.success("【"+this.cnName +"】数据同步完成。");
              this.msg="【"+this.cnName +"】数据同步完成，请点 [ 显示数据 ]。";
            }
            else {
              this.timer2 = setTimeout(this.getStatus2, 5000);
              this.msg='数据同步中.....';
              this.$message.warning("【"+this.cnName +"】数据同步中.....");
            }
          })
        },
        //查询是否有同步订单 或同步备注在进行
        isRunning:function(name){
          if (name == "GetTrades") {
            if ((this.tradeDate == null) || (this.tradeDate.length == 0)) {
              this.$message.error("请先选择起止日期后，再同步订单");
              return;
            }
          }
          let param={
            nick:storage.get("nick"),
            subnick:'',
            funName:'',
            status:"1",
          }
          $api.post("/trade/isRunning", param, response =>{
            console.log(response);
            let dataResult =  response.data;
            if(dataResult.state == 1) {
              if (dataResult.data == "success") {
                if (name == "GetTrades") {
                  this.getTbData();
                } else if (name == "GetMemo") {
                  this.getMemo();
                }
              }
              else {
                this.$message.warning("上次的同步还没有结束或有其他用户正在同步订单，请稍后再试...");
              }
            }
            else {
              this.$message.error(dataResult.message);
            }
          })
        },


        //用户点了同步订单 即将开始同步数，检测是否满足同步条件
        startTrade:function() {
          //同步订单时只能选最近3个月的
          if(this.tradeDate == null){
            this.$message.error("请选择要同步的订单的时间范围");
            return;
          }else{
            let now = new Date();
            let start = new Date(this.tradeDate[0]);
            let end = new Date(this.tradeDate[1]);
            let diff = end.getTime() - start.getTime();
            //if(diff >  30 * 24 * 60 * 60 * 1000){
            // if( !isInSameMonth(start, end)){
            //   this.$message.error("错误：时间跨度不能超过1个月！");
            //   return;
            // }
          }
          //检查有没有包含当天的时间
          let msg = "开始同步数据，完成后请点【显示数据】查看，是否继续?";
          let title = "提示";
          let date =  new Date();
          let endDate = new Date(this.tradeDate[1]);
          let diff = endDate.getTime() - date.getTime();
          if(diff < -10 * 60 * 1000){
            title="重要提示，一定要看";
            msg = "结束时间不是今天，会导致今天的订单不显示，点【取消】修改时间，点【确定】忽略提示";
          }
          this.$confirm(msg, title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            console.log("cofirm.");
            //是否同步在进行
            this.isRunning("GetTrades");
          })
        },

        //先看订单量，小于15000，允许同步
        getTradeSoldCount:function(){

          let param={
            nick: storage.get("nick"),
            subNick:storage.get("subnick"),
            synValue:this.synValue,
            startDate: this.tradeDate[0],
            endDate: this.tradeDate[1],
            orderState: this.checkedStatus,
            deviceId: cookies.getCookie("deviceId"),
            funName:this.funName,
          };
          $api.post("/trade/gettbcount", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              let rows = dataResult.data;
              if(rows <= 10000){
                this.getTbData();
              }else{
                this.$message.error("订单量超限，请缩短同步订单的起止时间后再同步")
              }
            }else {
              this.$message.error(dataResult);
            }
          })
        },
        //开始同步订单数据
        getTbData:function () {
          this.funName="GetTrades";
          this.cnName=" 订单 ";

          storage.set("synValue", this.synValue);
          storage.set("created", this.tradeDate);
          storage.set("checkedStatus", this.checkedStatus);

          let param={
            nick: storage.get("nick"),
            synValue:this.synValue,
            startDate: this.tradeDate[0],
            endDate: this.tradeDate[1],
            status: this.checkedStatus,
            //deviceId: cookies.getCookie("deviceId"),
            funName:this.funName,
          };
          $api.post("/trade/gettb", param, response => {
            console.log("start");
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              //this.$message.success('同步订单完成，请查看数据！');
              this.msg='数据同步中.....';
              this.timer = setTimeout(this.getStatus, 1000);
              //this.timer2 = setTimeout(this.getStatus2, 1000);
            }else {
              this.$message.error(dataResult);
            }
          })
        },


        startMemo:function() {
          this.$confirm('即将开始从1688获取数据，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            //是否同步在进行
            this.isRunning("GetMemo")

          })
        },
        //同步备注
        getMemo:function () {
          if(this.msg =="running" ){
            this.$message.error("正在同步数据，请稍候...");
            return;
          }
          this.funName="GetMemo";
          this.cnName=" 备注 ";
          //console.log(storage.get("subnick"));
          let param={
            nick: storage.get("nick"),
            venderId:storage.get("venderId"),
            funName:this.funName,
          };
          $api.post("/trade/getmemo", param, response => {
            console.log("start");
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.timer = setTimeout(this.getStatus, 1000);
              //this.timer2 = setTimeout(this.getStatus2, 1000);
            }else {
              this.$message.error(dataResult);
            }
          })
        },
        //同步退货
        getAsc:function () {
          this.funName="GetTrades";
          this.cnName=" 退货订单 ";
          let param={
            nick: storage.get("nick"),
            venderId:storage.get("venderId"),
            funName:this.funName,
          };
          $api.post("/asc/gettb", param, response => {
            console.log("start");
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.timer = setTimeout(this.getStatus, 1000);
            }else {
              this.$message.error(dataResult);
            }
          })
        },

        //开始优惠数据
        getCoup:function () {
          this.funName="GetTrades";
          this.cnName=" 优惠 ";

          storage.set("synValue", this.synValue);
          storage.set("created", this.tradeDate);
          storage.set("checkedStatus", this.checkedStatus);

          let param={
            nick: storage.get("nick"),
            venderId:storage.get("venderId"),
            synValue:this.synValue,
            startDate: this.tradeDate[0],
            endDate: this.tradeDate[1],
            orderState: this.checkedStatus,
            deviceId: cookies.getCookie("deviceId"),
            funName:this.funName,
          };
          $api.post("/trade/getcoup", param, response => {
            console.log("start");
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.msg='数据同步中.....';
              this.timer = setTimeout(this.getStatus, 1000);
              //this.timer2 = setTimeout(this.getStatus2, 1000);
            }else {
              this.$message.error(dataResult);
            }
          })
        },

        //显示一条数据
        getTradeData: function () {
          console.log(this.timeField);
          if(this.payTime == null){
            this.payTime=[];
          }
          let param = {
            nick:  storage.get("nick"),

            pageCurrent: 1,
            rowCount: 0,
            pageSize: 0,
          };
          $api.post("/trade/get", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              let tradeData = dataResult.data.trade;
              let pageObject = dataResult.data.pageObject;
              this.msg = this.msg + " 本次共同步到数据 " + pageObject.rowCount + "条";
            }
            else {
              this.$message.error(dataResult);
            }
          })
        },
        //保存显示顺序
        saveField:function(){
          this.checkedFields = [],
            storage.set("field",this.myFields);
          for(let i=0;i<this.myFields.length;i++){
            this.checkedFields.push(this.myFields[i].field);
          }
          storage.set("checked", this.checkedFields);
          console.log(this.checkedFields);
          this.$message.success("保存显示属性成功")
        },
        //保存到服务器
        addField:function () {
          let fields ="";
          console.log(this.checkedFields.length);
          if(this.checkedFields.length==0){
            this.$message.error("请先选择显示属性，再保存");
            return
          }else {
            for(let i=0;i<this.checkedFields.length;i++){
              fields = fields + this.checkedFields[i] + ",";
            }
          }
          console.log(fields);
          let param={
            nick: storage.get("nick"),
            venderId: storage.get("venderId"),
            newFields: fields,
          }
          $api.post("/trade/addField", param, response=>{
            let dataResult = response.data;
            if((dataResult.state == 1) && (dataResult.message=="ok")){
              this.saveField();
              this.$message.success("显示顺序已保存到服务器。")
            }else{
              this.$message.error(dataResult)
            }

          })
        },
        //从服务器下载
        getField:function () {
          let param={
            nick: storage.get("nick"),
            venderId:storage.get("venderId"),
          }
          $api.post("/trade/getField", param, response=>{
            let dataResult = response.data;
            if((dataResult.state == 1) && (dataResult.message=="ok")){
              if(dataResult.data == ""){
                this.$message.error("您还没有保存过显示顺序。")
              }else{
                console.log(dataResult.data)
                this.checkedFields = dataResult.data.split(",");
                this.fillTitle();
                this.saveField();
                this.$message.success("从服务器下载显示顺序成功。")
              }
            }else{
              this.$message.error(dataResult)
            }

          })
        },
        //是否有用户步订单或同步备注
        isGetRunning:function(){
          this.isGetTradesRun();
          if(this.isdoing == 0){
            this.isGetMemoRun();
          }
        },

        //查询是否有用户同时同步订单
        isGetTradesRun:function () {
          this.msg='';
          let param={
            nick:storage.get("nick"),
            subnick:'all',
            funName:"GetTrades",
            status:"1",
          }
          $api.post("/trade/getStatus", param, response =>{
            let dataResult =  response.data;
            if(dataResult.data == "success") {
              this.isdoing = 0;
            }
            else {
              this.isdoing = 1;
            }
            console.log("getTrades");
            console.log(this.isdoing);
          })

        },
        //查询是否有用户同时同步订单
        isGetMemoRun:function () {
          this.msg='';
          let param={
            nick:storage.get("nick"),
            subnick:'all',
            funName:"GetMemo",
            status:"1",
          }
          $api.post("/trade/getStatus", param, response =>{
            let dataResult =  response.data;
            if(dataResult.data == "success") {
              this.isdoing = 0;
            }
            else {
              this.isdoing = 1;
            }
            console.log("getMemo");
            console.log(this.isdoing);
          })
        },
        //调整显示顺序相关操作
        indexMethod(index)
        {
          return index + 1;
        },
        openItem:function(){
          //this.seqFields = this.myFields;
          this.seqFields = [];
          for(let i=0;i<this.myFields.length;i++){
            this.seqFields.push(this.myFields[i]);
          }
          this.showItem = true;
        },
        handleCurrentChange:function(val){
          this.currentRow = val;
          let idx = this.getIndex(val);
          console.log('idx:' + idx);

        },
        getIndex:function(val){
          for(let i=0;i<this.seqFields.length;i++){
            if(val.field == this.seqFields[i].field){
              return i;
            }
          }
          return -1;
        },
        up:function(){
          if(this.currentRow == null){
            this.$message.error('请先选一个要调整的项');
            return
          }
          let index = this.getIndex(this.currentRow);
          if(index>0) {
            if(this.seqFields[index].title == "主图")
              return;
            this.seqFields.splice(index, 1);
            this.seqFields.splice(index - 1, 0, this.currentRow);
          }
        },
        down:function(){
          if(this.currentRow == null){
            this.$message.error('请先选一个要调整的项');
            return
          }
          let index = this.getIndex(this.currentRow);
          if(index<this.seqFields.length-1) {
            if(this.seqFields[index].title == "主图")
              return;
            this.seqFields.splice(index, 1);
            this.seqFields.splice(index+1, 0, this.currentRow);
          }
        },
        moveUp:function (index, row) {
          if(index>0) {
            if(this.seqFields[index].title == "主图")
              return;
            this.seqFields.splice(index, 1);
            this.seqFields.splice(index - 1, 0, row);
          }
        },
        moveDown:function (index, row) {
          if(index<this.seqFields.length-1) {
            if(this.seqFields[index].title == "主图")
              return;
            this.seqFields.splice(index, 1);
            this.seqFields.splice(index+1, 0, row);
          }
        },
        saveItem:function () {
          this.myFields = [];
          for(let i=0;i<this.seqFields.length;i++){
            this.myFields.push(this.seqFields[i]);
          }
          this.saveField();
          this.showItem = false;

        },
        cancelItem:function () {
          this.seqFields = [];
          this.showItem =false;
        }
      },
      mounted() {

        //同步选项
        let checkedStatus=storage.get("checkedStatus");
        if(checkedStatus!=null){
          this.synValue = storage.get("synValue");
          this.checkedStatus = storage.get("checkedStatus");
        }
        let created = storage.get("created");
        if(created != null){
          this.tradeDate = storage.get("created");
        }else {
          this.tradeDate=[];
          //当前设定的日期时间
          let d = new Date
          let year1, month1, day1;
          [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()]
          let date1 = new Date(year1, month1, day1, 23, 59, 59)
          //this.tradeDate.push(date1)

          //前一天设定的日期时间
          let year2, month2, day2
          d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
          [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()]
          let date2 = new Date(year2, month2, day2, 0)
          //this.tradeDate.unshift(date2)
          this.tradeDate.push(datefmt.dateFormat("yyyy-MM-dd HH:mm:ss", date2))
          this.tradeDate.push(datefmt.dateFormat("yyyy-MM-dd HH:mm:ss", date1))
        }

        let hasFiled=true;
        let field = storage.get("field");
        if(field != null){
          this.myFields = storage.get("field");
        }
        let checkedField = storage.get("checked");
        if(checkedField != null){
          this.checkedFields = storage.get("checked");
        }else{
          hasFiled =false;
          //如果用户没有设置过，则从服务器下载一次
          //this.getField();

        }
        //this.fillTitle();
        if(!hasFiled){
          storage.set("field",this.myFields);
          storage.set("checked", this.checkedFields);
        }
        let venderId = storage.get("venderId");
        if(venderId == "625412"){
          this.showAsc = true;
        }
        if(venderId == "132922"){
          this.showCoup = true;
        }
        if(((venderId == "41178")) || (venderId == "62934")){
          this.showCoup = true;
        }
      }
    }
</script>

<style >
  .border{
    padding: 5px 15px;
    border: #E4E7ED 1px solid ;
  }

  .border15{
    padding: 15px 15px;
    border: #E4E7ED 1px solid ;
  }

  .el-checkbox__label{
    font-size: 14px;
    color:#000;
    padding: 0px 0px 0px 3px;
  }

  .el-checkbox.is-checked{
    color: #000;
  }

  .hover  .el-table__body tr> td {
    padding: 5px 0;
  }

  .hover  .el-table__body tr:hover > td {
    background-color: #a4da89 !important;
  }

  .hover .el-table__body tr.current-row>td {
    background-color: #a4da89;
    padding: 12px 0;

  }

  .hover .el-table .cell{
    padding: 5px 0;
  }


</style>



// WEBPACK FOOTER //
// src/page/ShowSet.vue